import React from 'react';
import styled from '@emotion/styled';

const StyledEnvStatus = styled.div<{ fontSize?: string }>`
  color: #024d5f;
  font-size: ${(props) => props?.fontSize ?? '18px'};
`;

interface IEnvStatusProps {
  fontSize?: string;
}

const EnvStatus = ({ fontSize }: IEnvStatusProps) => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;

  const getEnvStatus = () => {
    if (!env) return null;
    return env.toUpperCase();
  };

  if (env === 'production') return null;
  return <StyledEnvStatus fontSize={fontSize}>{getEnvStatus()}</StyledEnvStatus>;
};

export default EnvStatus;
